import { render, staticRenderFns } from "./CardReviewOffering.vue?vue&type=template&id=f5f0b674&scoped=true"
import script from "./CardReviewOffering.vue?vue&type=script&lang=js"
export * from "./CardReviewOffering.vue?vue&type=script&lang=js"
import style0 from "./CardReviewOffering.vue?vue&type=style&index=0&id=f5f0b674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f0b674",
  null
  
)

export default component.exports